<section class="admin-page ct-page">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'orders.subtitle' | t }}</p>
    </div>
  </div>

  <form class="filters" (submit)="onSearchSubmit($event)">
    <input
      class="ct-input"
      type="search"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      name="search"
      [attr.placeholder]="'orders.searchPlaceholder' | t"
    />
    <button class="ct-btn ct-btn-primary" type="submit">{{ 'orders.filter' | t }}</button>
  </form>

  <div class="ct-card ct-table-wrap">
    <table class="ct-table">
      <thead>
        <tr>
          <th>{{ 'orders.created' | t }}</th>
          <th>{{ 'orders.customer' | t }}</th>
          <th>{{ 'orders.email' | t }}</th>
          <th class="col-status">{{ 'common.status' | t }}</th>
          <th class="col-price">{{ 'orders.total' | t }}</th>
          <th>{{ 'orders.lines' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (loading()) {
          <tr>
            <td colspan="7">{{ 'common.loading' | t }}</td>
          </tr>
        } @else if (items().length === 0) {
          <tr>
            <td colspan="7">{{ 'orders.empty' | t }}</td>
          </tr>
        } @else {
          @for (item of items(); track item.id) {
            <tr>
              <td>{{ item.createdAt | date: 'medium' }}</td>
              <td>{{ customerName(item) }}</td>
              <td>{{ item.customerEmail }}</td>
              <td class="col-status">
                <span class="ct-badge" [class.ct-badge-success]="item.status === 'Paid'" [class.ct-badge-warn]="item.status === 'Pending'">
                  {{ statusLabel(item.status) }}
                </span>
              </td>
              <td class="col-price">{{ money(item.total) }}</td>
              <td>{{ item.lineCount }}</td>
              <td class="actions">
                @if (item.status === 'Paid') {
                  <button
                    class="ct-btn ct-btn-ghost ct-btn-sm orders-pdf-btn"
                    type="button"
                    [disabled]="isDownloadingPdf(item.id)"
                    (click)="downloadPdfFromList(item)"
                  >
                    {{ 'orders.pdf' | t }}
                  </button>
                }
                <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openDetail(item)">
                  {{ 'orders.view' | t }}
                </button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  @if (totalCount() > items().length) {
    <p class="hint">{{ 'orders.showing' | t: { shown: items().length, total: totalCount() } }}</p>
  }
</section>

@if (detailOpen()) {
  <div class="ct-dialog-backdrop" (click)="closeDetail()">
    <div class="ct-dialog order-dialog" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <header class="ct-dialog-head"><h2>{{ 'orders.detail' | t }}</h2>        <button type="button" class="ct-dialog-close" (click)="closeDetail()" [attr.aria-label]="'common.close' | t">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>      </header>
      <div class="ct-dialog-body">
      @if (detailLoading()) {
        <p>{{ 'common.loading' | t }}</p>
      } @else if (selected()) {
        @let order = selected()!;
        <div class="detail-grid">
          <div>
            <div class="label">{{ 'orders.customer' | t }}</div>
            <div>{{ customerName(order) }}</div>
            <div>{{ order.customerEmail }}</div>
            <div>{{ order.customerPhone }}</div>
          </div>
          <div>
            <div class="id-line">{{ 'orders.orderId' | t }} {{ order.orderNumber }}</div>
            <div class="id-line">
              {{ 'common.status' | t }}:
              <span class="ct-badge" [class.ct-badge-success]="order.status === 'Paid'" [class.ct-badge-warn]="order.status === 'Pending'">
                {{ statusLabel(order.status) }}
              </span>
            </div>
            @if (order.paidAt) {
              <div class="id-line">{{ 'orders.paid' | t }}: {{ formatPaidAt(order.paidAt) }}</div>
            }
          </div>
        </div>

        <h3>{{ 'orders.lineItems' | t }}</h3>
        <div class="ct-table-wrap">
          <table class="ct-table lines-table">
            <thead>
              <tr>
                <th>{{ 'orders.item' | t }}</th>
                <th>{{ 'orders.type' | t }}</th>
                <th>{{ 'portal.product.quantity' | t }}</th>
                <th>{{ 'orders.price' | t }}</th>
                <th>{{ 'orders.lineTotal' | t }}</th>
              </tr>
            </thead>
            <tbody>
              @for (line of order.lines; track line.id) {
                <tr>
                  <td>
                    <div class="item-name">{{ line.name }}</div>
                    @for (opt of parseBundleOptions(line.bundleOptionsJson); track opt.productId) {
                      <div class="option">
                        • {{ opt.name }}
                        @if (opt.unitPrice > 0) {
                          ({{ money(opt.unitPrice) }})
                        }
                      </div>
                    }
                  </td>
                  <td>{{ line.lineType }}</td>
                  <td class="num">{{ line.quantity }}</td>
                  <td class="num">{{ money(line.unitPrice) }}</td>
                  <td class="num">{{ money(line.lineTotal) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="totals">
          <div>{{ 'orders.subtotal' | t }}: {{ money(order.subtotal) }}</div>
          <div>{{ 'orders.tax' | t }}: {{ money(order.taxAmount) }}</div>
          <div class="total">
            {{ 'orders.total' | t }}: {{ money(order.total) }}
            {{ order.currency.toUpperCase() }}
          </div>
        </div>

        @if (order.stripePaymentIntentId) {
          <p class="meta mono">PI: {{ order.stripePaymentIntentId }}</p>
        }
      }

      </div>
        <div class="ct-dialog-actions">
        @if (selected()) {
          <button
            class="ct-btn ct-btn-primary orders-pdf-btn"
            type="button"
            [disabled]="isDownloadingPdf(selected()!.id)"
            (click)="downloadPdf(selected()!)"
          >
            {{ 'orders.downloadPdf' | t }}
          </button>
        }
        <button class="ct-btn ct-btn-ghost" type="button" (click)="closeDetail()">
          {{ 'common.close' | t }}
        </button>
      </div>
    </div>
  </div>
}
